class WindowProvider {
  public getWindow: () => Window = () => window;
}

export default new WindowProvider();
